import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import {CalendarModule} from 'primeng/primeng';

import { CadensSharedModule } from '../../shared';

import {
    contactRoute, ContactService, ContactComponent
} from './';

let ENTITY_STATES = [
    ...contactRoute
];

@NgModule({
    imports: [
        CadensSharedModule,
        CalendarModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ContactComponent
    ],
    entryComponents: [
        ContactComponent
    ],
    providers: [
        ContactService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensContactModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact/contact.module.ts